import { render, staticRenderFns } from "./_base-input.vue?vue&type=template&id=13a49cbf&scoped=true&"
import script from "./_base-input.vue?vue&type=script&lang=js&"
export * from "./_base-input.vue?vue&type=script&lang=js&"
import style0 from "./_base-input.vue?vue&type=style&index=0&id=13a49cbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a49cbf",
  null
  
)

export default component.exports